import { useState } from "react";
import "./ServicesEditForm.scss";

// Solo dejamos los "huecos" vacíos (strings vacíos) con la cantidad exacta que necesitas
const DEFAULT_DATA = {
  residenciales: ["", "", ""], // 3 tarjetas vacías
  patrimoniales: ["", "", "", ""], // 4 tarjetas vacías
  transversales: ["", ""], // 2 tarjetas vacías
};

export default function ServicesForms({ webData, refreshData }) {
  const servicesData = webData?.services || {};
  const webHomeId = webData?._id;

  return (
    <div className="ServicesEditForm">
      <div className="ServicesEditForm__title">
        <h2>Administrar Secciones de Servicios</h2>
      </div>

      <ServiceSectionForm
        sectionKey="residenciales"
        titleLabel="Servicio 1"
        initialData={servicesData.residenciales}
        defaultCards={DEFAULT_DATA.residenciales}
        webHomeId={webHomeId}
        refreshData={refreshData}
      />

      <ServiceSectionForm
        sectionKey="patrimoniales"
        titleLabel="Servicio 2"
        initialData={servicesData.patrimoniales}
        defaultCards={DEFAULT_DATA.patrimoniales}
        webHomeId={webHomeId}
        refreshData={refreshData}
      />

      <ServiceSectionForm
        sectionKey="transversales"
        titleLabel="Servicio 3"
        initialData={servicesData.transversales}
        defaultCards={DEFAULT_DATA.transversales}
        webHomeId={webHomeId}
        refreshData={refreshData}
      />
    </div>
  );
}

// Subcomponente de formulario
function ServiceSectionForm({
  sectionKey,
  titleLabel,
  initialData,
  defaultCards,
  webHomeId,
  refreshData,
}) {
  // ATENCIÓN AQUÍ: Recuperamos initialData para que si ya hay datos en BBDD, se muestren.
  const [title, setTitle] = useState(initialData?.title || "");
  const [subtitle, setSubtitle] = useState(initialData?.subtitle || "");
  const [imagePreview, setImagePreview] = useState(initialData?.image || "");
  const [selectedFile, setSelectedFile] = useState(null);
  const [saving, setSaving] = useState(false);

  const [cards, setCards] = useState(() => {
    if (initialData?.cards && initialData.cards.length > 0) {
      return initialData.cards.map((c) => c.text);
    }
    return defaultCards;
  });

  const handleCardChange = (index, value) => {
    const newCards = [...cards];
    newCards[index] = value;
    setCards(newCards);
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setSelectedFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!webHomeId) return alert("Falta el ID de WebHome");

    setSaving(true);
    try {
      const formData = new FormData();
      formData.append("key", sectionKey);
      formData.append("title", title);
      formData.append("subtitle", subtitle);
      formData.append("cardsText", JSON.stringify(cards));

      if (selectedFile) formData.append("image", selectedFile);

      const apiUrl = process.env.REACT_APP_BASE_URL;
      const res = await fetch(`${apiUrl}/web/services/${webHomeId}`, {
        // Ojo, en tu endpoint del back pusiste "/web/services/section/:id"
        method: "PUT",
        body: formData,
      });

      if (res.ok) {
        alert(`${titleLabel} guardado correctamente.`);
        refreshData();
        setSelectedFile(null);
      } else {
        const errorData = await res.json();
        alert(`Error al guardar: ${errorData.message}`);
      }
    } catch (error) {
      console.error(error);
      alert("Error de conexión al guardar.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSave} className="ServicesEditForm__form">
      <div className="ServicesEditForm__title">
        <h3>{titleLabel}</h3>
      </div>

      <div className="ServicesEditForm__item">
        <label>Título</label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="yearInput yearInput--wide"
        />
      </div>

      <div className="ServicesEditForm__item">
        <label>Descripción</label>
        <textarea
          value={subtitle}
          onChange={(e) => setSubtitle(e.target.value)}
          rows={4}
          className="ServicesEditForm__textarea-main"
        />
      </div>

      <div className="ServicesEditForm__item">
        <label>Imagen destacada</label>
        {imagePreview && (
          <img
            src={imagePreview}
            alt="Vista previa"
            className="ServicesEditForm__image-preview"
          />
        )}
        <input type="file" accept="image/*" onChange={handleFileChange} />
      </div>

      <div className="ServicesEditForm__item ServicesEditForm__item--cards">
        <h4>Tarjetas de texto ({cards.length})</h4>

        <div className="Services__box">
          {cards.map((cardText, index) => (
            <div key={index} className="Services__box__item">
              <label>Tarjeta {index + 1}</label>
              <textarea
                value={cardText}
                onChange={(e) => handleCardChange(index, e.target.value)}
                rows={6}
                placeholder={`Escribe el texto de la tarjeta ${index + 1}...`}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="ServicesEditForm__buttons">
        <button
          type="submit"
          disabled={saving}
          className="ServicesEditForm__btn"
        >
          {saving ? "Guardando..." : "Guardar"}
        </button>
      </div>
    </form>
  );
}
